var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIconModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836",
    transform: "translate(0 -0.381)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(0 0.381)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(15 15.381)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(30 30.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835",
    transform: "translate(30 30.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M-1056.59,355.938c-.32-.046-.639-.091-.958-.135-.71-.1-1.444-.2-2.151-.329a29.338,29.338,0,0,1-19.063-11.975,29.128,29.128,0,0,1-5.194-23.119,29.146,29.146,0,0,1,9.268-16.591,29.345,29.345,0,0,1,14.925-7.384c.723-.128,1.471-.231,2.2-.331.326-.045.652-.09.979-.137h4.218c.3.04.594.076.892.113.656.081,1.335.165,1.987.279a29.659,29.659,0,0,1,14.638,6.946,29.651,29.651,0,0,1,9.892,17.385c.131.72.232,1.466.33,2.188q.066.491.136.98v4.189l-.021.091c-.031.139-.068.3-.091.466-.047.346-.088.693-.127,1.039-.079.675-.153,1.313-.277,1.944a29.764,29.764,0,0,1-9.187,16.454,29.387,29.387,0,0,1-15.005,7.459c-.721.128-1.469.23-2.191.329q-.49.066-.98.136Zm2.077-57.753a27.748,27.748,0,0,0-27.7,27.691,27.8,27.8,0,0,0,27.68,27.8h.068a27.894,27.894,0,0,0,27.724-27.7,27.469,27.469,0,0,0-8.108-19.594,27.6,27.6,0,0,0-19.619-8.2Z",
    transform: "translate(1084.497 -295.938)",
    fill: "#28a745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M-1052.17,350.4a2.526,2.526,0,0,1-1.517-.922l-2.669-2.672c-2.3-2.3-4.685-4.688-7.018-7.04a1.731,1.731,0,0,1-.527-1.606,1.419,1.419,0,0,1,1-1.019,1.663,1.663,0,0,1,.509-.088,1.653,1.653,0,0,1,1.165.584q2.323,2.34,4.656,4.67,1.47,1.471,2.938,2.944c.1.1.212.229.374.417.1.115.213.248.353.407l.891,1.012.784-1.1c.1-.138.182-.263.258-.378a2.627,2.627,0,0,1,.238-.329q4.631-4.645,9.265-9.289,6.814-6.831,13.624-13.666a1.815,1.815,0,0,1,1.3-.7,1.605,1.605,0,0,1,.536.1,1.478,1.478,0,0,1,.95,1,1.507,1.507,0,0,1-.309,1.376c-.13.157-.289.315-.458.482l-.142.141-24.712,24.762A2.47,2.47,0,0,1-1052.17,350.4Z",
    transform: "translate(1074.486 -306.007)",
    fill: "#28a745"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIconModal);
export default __webpack_public_path__ + "static/media/SuccessIconModal.1b919390.svg";
export { ForwardRef as ReactComponent };